/**
    Form methods
    @readonly
    @enum {string}
*/
export var HTTPMETHOD;
(function (HTTPMETHOD) {
    HTTPMETHOD["DEFAULT"] = "POST";
    HTTPMETHOD["POST"] = "POST";
    HTTPMETHOD["GET"] = "GET";
    HTTPMETHOD["PUT"] = "PUT";
})(HTTPMETHOD || (HTTPMETHOD = {}));
;
